<template>
	<div class="container">
		<el-tabs v-model="activeName" @tab-click="handleClick" :class="'custom-tabs-' + activeName">
			<el-tab-pane label="代理商投诉一览表" name="adminComplaintBoard">
				<div class="handle-box">
					<el-select size="small" v-model="query2.operator" filterable clearable placeholder="品牌"
						style="width: 180px;" class="handle-select mr10">
						<el-option v-for="item in cardTypeData" :key="item.value" :label="item.value"
							:value="item.value"></el-option>
					</el-select>
					<el-select size="small" v-model="query2.standard" clearable filterable placeholder="请选择制式"
						style="width: 180px;margin-right: 10px;">
						<el-option v-for="item in standardList" :key="item.label" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
					<el-date-picker size="small" v-model="timeArr2" type="month" class="m_r_10"></el-date-picker>
					<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
						@click.stop="getAgentWorkOrder">搜索</el-button>
					<el-button size="small" type="primary" :class="[theme]" icon="el-icon-download"
						@click.stop="getdownloadAgentWorkOrder">下载</el-button>
				</div>
				<div class="card-body">
					<div class="tit">
						<div><i class="el-icon-s-data"></i>总投诉数据</div>
					</div>
					<div class="card-list">
						<div class="bg_ecf4ff">
							<span class="card-list-tit">在网</span>
							<span class="card-list-data">{{customDataTotal.use||0}}</span>
						</div>
						<div class="bg_ecf4ff">
							<span class="card-list-tit">总投诉个数</span>
							<span class="card-list-data">{{customDataTotal.totalCount||0}}</span>
						</div>
						<div class="bg_ecf4ff">
							<span class="card-list-tit">12321骚扰</span>
							<span class="card-list-data">{{customDataTotal.sr||0}}</span>
						</div>
						<div class="bg_ecf4ff">
							<span class="card-list-tit">12321诈骗</span>
							<span class="card-list-data">{{customDataTotal.zp||0}}</span>
						</div>
						<div class="bg_ecf4ff">
							<span class="card-list-tit">省公安协查</span>
							<span class="card-list-data">{{customDataTotal.sga||0}}</span>
						</div>
						<div class="bg_ecf4ff">
							<span class="card-list-tit">公安部协查</span>
							<span class="card-list-data">{{customDataTotal.gab||0}}</span>
						</div>
					</div>
				</div>
				<el-table :data="tableData2" border class="table" ref="multipleTable"
					header-cell-class-name="table-header" :header-cell-style="{ 'text-align': 'center' }"
					@selection-change="handleSelectionChange" :row-style="{ height: '20px' }" v-loading="loading"
					:cell-style="{ padding: '6px' }" stripe style="width: 100%">
					<el-table-column type="selection" width="55" align="center"></el-table-column>
					<el-table-column prop="vestingPerson" label="代理商" align="center" min-width="210"></el-table-column>
					<el-table-column prop="use" label="在网" sortable align="center" min-width="110"></el-table-column>
					<el-table-column prop="totalCount" label="投诉个数" min-width="110" sortable
						align="center"></el-table-column>
					<el-table-column prop="ratio" label="诉比" min-width="110" align="center" sortable>
						<template #header>
							<span style="margin-right: 5px">诉比</span>
							<el-tooltip effect="dark" content="代理商在网数量除以投诉数量" placement="top">
								<i class="el-icon-warning" style="color: #E6A23C; cursor: pointer" />
							</el-tooltip>
						</template>
					</el-table-column>
					<el-table-column prop="12321sr" label="12321骚扰" min-width="110" sortable
						align="center"></el-table-column>
					<el-table-column prop="12321zp" label="12321诈骗" min-width="110" sortable
						align="center"></el-table-column>
					<el-table-column prop="sga" label="省公安协查" min-width="110" sortable align="center"></el-table-column>
					<el-table-column prop="gab" label="公安部协查" min-width="110" sortable align="center"></el-table-column>
					<el-table-column prop="workOrderLog" label="备注" align="center" min-width="210">
						<template #default="scope">
							<span v-if="scope.row.workOrderLog[0]">{{scope.row.workOrderLog[0].content}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="workOrderLog" label="备注时间" align="center" width="160">
						<template #default="scope">
							<span v-if="scope.row.workOrderLog[0]">{{scope.row.workOrderLog[0].time}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="workOrderLog" label="操作" align="center" min-width="160" fixed="right">
						<template #default="scope">
							<el-button size="small" type="primary" :class="[theme]"
								@click="showAdd(scope.row)">添加</el-button>
							<el-button size="small" type="primary" :class="[theme]"
								@click="showRecord(scope.row)">记录</el-button>
						</template>
					</el-table-column>
				</el-table>

			</el-tab-pane>
			<el-tab-pane label="企业投诉看板" name="agentComplaintBoard">
				<div class="handle-box">
					<el-select size="small" @change="agentChange" v-model="query3.agentId" filterable clearable
						placeholder="代理商" class="handle-select mr10" style="width: 260px">
						<el-option v-for="item in agents" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
					<el-select size="small" v-model="query3.companyId" filterable clearable placeholder="企业"
						class="handle-select mr10" style="width: 260px">
						<el-option v-for="item in companys" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
					<el-select size="small" v-model="query3.operator" filterable clearable placeholder="品牌"
						style="width: 180px;" class="handle-select mr10">
						<el-option v-for="item in cardTypeData" :key="item.value" :label="item.value"
							:value="item.value"></el-option>
					</el-select>
					<el-select size="small" v-model="query3.standard" clearable filterable placeholder="请选择制式"
						style="width: 180px;margin-right: 10px;">
						<el-option v-for="item in standardList" :key="item.label" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
					<el-date-picker v-model="timeArr3" style="width: 280px;margin-right: 10px;margin-top: 10px;"
						type="daterange" unlink-panels range-separator="至" start-placeholder="开始日期"
						end-placeholder="结束日期" size="small"></el-date-picker>
					<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
						@click.stop="getCompanyWorkOrder">搜索</el-button>
					<el-button size="small" type="primary" :class="[theme]" icon="el-icon-download"
						@click.stop="getdownloadCompanyWorkOrder">下载</el-button>

				</div>
				<div class="card-body">
					<div class="tit">
						<div><i class="el-icon-s-data"></i>总投诉数据</div>
					</div>
					<div class="card-list">
						<div class="bg_ecf4ff">
							<span class="card-list-tit">总投诉个数</span>
							<span class="card-list-data">{{customData.totalComplaints||0}}</span>
						</div>
						<div class="bg_ecf4ff">
							<span class="card-list-tit">12321骚扰</span>
							<span class="card-list-data">{{customData.sr||0}}</span>
						</div>
						<div class="bg_ecf4ff">
							<span class="card-list-tit">12321诈骗</span>
							<span class="card-list-data">{{customData.zp||0}}</span>
						</div>
						<div class="bg_ecf4ff">
							<span class="card-list-tit">省公安协查</span>
							<span class="card-list-data">{{customData.sga||0}}</span>
						</div>
						<div class="bg_ecf4ff">
							<span class="card-list-tit">公安部协查</span>
							<span class="card-list-data">{{customData.gab||0}}</span>
						</div>
					</div>
				</div>
				<el-table :data="tableData3" border class="table" ref="multipleTable" max-height="600"
					header-cell-class-name="table-header" :header-cell-style="{ 'text-align': 'center' }"
					v-loading="loading" :row-style="{ height: '20px' }" :cell-style="{ padding: '6px' }" stripe
					style="width: 100%" @selection-change="handleSelectionChange">
					<el-table-column type="selection" width="55" align="center"></el-table-column>
					<el-table-column prop="agentName" label="代理商" align="center" min-width="170"></el-table-column>
					<el-table-column prop="companyName" label="企业" align="center" min-width="210"></el-table-column>
					<el-table-column prop="use" label="在网" sortable align="center" min-width="110"></el-table-column>
					<el-table-column prop="totalComplaints" min-width="100" sortable label="投诉个数"
						align="center"></el-table-column>
					<el-table-column prop="12321sr" min-width="110" label="12321骚扰" sortable
						align="center"></el-table-column>
					<el-table-column prop="12321zp" min-width="110" label="12321诈骗" sortable
						align="center"></el-table-column>
					<el-table-column prop="sga" min-width="110" label="省公安协查" sortable align="center"></el-table-column>
					<el-table-column prop="gab" min-width="110" label="公安部协查" sortable align="center"></el-table-column>
					<el-table-column prop="workOrderLog" label="备注" align="center" min-width="210">
						<template #default="scope">
							<span v-if="scope.row.workOrderLog[0]">{{scope.row.workOrderLog[0].content}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="workOrderLog" label="备注时间" align="center" min-width="160">
						<template #default="scope">
							<span v-if="scope.row.workOrderLog[0]">{{scope.row.workOrderLog[0].time}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="workOrderLog" label="操作" align="center" min-width="145" fixed="right">
						<template #default="scope">
							<el-button size="small" type="primary" :class="[theme]"
								@click="showAdd(scope.row)">添加</el-button>
							<el-button size="small" type="primary" :class="[theme]"
								@click="showRecord(scope.row)">记录</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="pagination">
					<el-pagination background layout="total, sizes, prev, pager, next, jumper"
						:current-page="query3.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
						:page-size="query3.pageSize" :total="pageTotal3" @size-change="handleSizeChange3"
						@current-change="handlePageChange3"></el-pagination>
				</div>
			</el-tab-pane>
			<el-tab-pane label="工单管理" name="workOrder">
				<div class="handle-box">
					<el-input size="small" v-model="query.phoneNumber" clearable maxlength="12" placeholder="被举报号码"
						style="width: 180px;" class="handle-input mr10"></el-input>
					<el-select size="small" v-model="query.operator" filterable clearable placeholder="品牌"
						style="width: 180px;" class="handle-select mr10">
						<el-option v-for="item in cardTypeData" :key="item.value" :label="item.value"
							:value="item.value"></el-option>
					</el-select>
					<el-select size="small" @change="agentChange" v-model="query.vestingPerson" filterable clearable
						placeholder="代理商" class="handle-select mr10" style="width: 260px">
						<el-option v-for="item in agents" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
					<el-select size="small" style="width: 260px" v-model="query.companyName" @change="companyChange"
						filterable clearable placeholder="企业" class="handle-select mr10">
						<el-option v-for="item in companys" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
					<el-select size="small" v-model="query.standard" clearable filterable placeholder="请选择制式"
						style="width:180px;margin-right: 10px;">
						<el-option v-for="item in standardList" :key="item.label" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
					<el-select size="small" v-model="query.complaintChannel" filterable clearable placeholder="下发渠道"
						style="width: 180px;" class="handle-select mr10">
						<el-option v-for="item in complaintChannelList" :key="item.value" :label="item.value"
							:value="item.value"></el-option>
					</el-select>
					<el-select size="small" v-model="query.complaintType" filterable clearable placeholder="下发类型"
						style="width: 180px;" class="handle-select mr10">
						<el-option v-for="item in complaintTypeList" :key="item.value" :label="item.value"
							:value="item.value"></el-option>
					</el-select>
					<el-select size="small" v-model="query.whetherPay" filterable clearable placeholder="罚款是否收回"
						style="width: 180px;margin-top: 10px;" class="handle-select mr10">
						<el-option v-for="item in whetherPayList" :key="item.value" :label="item.label"
							:value="item.label"></el-option>
					</el-select>

					<el-input size="small" v-model="query.appealSuccessfully" clearable maxlength="12"
						placeholder="申诉成功" style="width: 180px;" class="handle-input mr10"></el-input>
					<el-date-picker v-model="timeArr" style="width: 280px;margin-right: 10px;margin-top: 10px;"
						type="daterange" unlink-panels range-separator="至" start-placeholder="开始日期"
						end-placeholder="结束日期" size="small"></el-date-picker>
					<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
						style="margin-top: 10px;" class="m_t_20" @click="handleSearch">搜索</el-button>
					<el-button size="small" type="primary" :class="[theme]" icon="el-icon-upload"
						style="margin-top: 10px;" class="m_t_20" @click="importForm">导入</el-button>

					<el-button size="small" type="primary" :class="[theme]" icon="el-icon-download"
						class="handle-del ml10" style="margin:10px 0 10px 10px;" @click="getdownload">
						下载模板
					</el-button>
					<el-button size="small" type="primary" :class="[theme]" icon="el-icon-upload2  el-icon--right"
						style="margin-top: 10px;" @click="exportData">导出</el-button>
					<el-button size="small" type="primary" :class="[theme]" icon="el-icon-upload2  el-icon--right"
						style="margin-top: 10px;" @click="batchDel">批量删除</el-button>
				</div>
				<el-table :data="tableData" border class="table" ref="multipleTable" max-height="600"
					header-cell-class-name="table-header" :header-cell-style="{ 'text-align': 'center' }"
					@selection-change="handleSelectionChange" :row-style="{ height: '20px' }" v-loading="loading"
					:cell-style="{ padding: '6px' }" stripe style="width: 100%">
					<el-table-column type="selection" width="55" align="center"></el-table-column>
					<el-table-column prop="operator" fixed min-width="120" label="运营商" align="center"></el-table-column>
					<el-table-column prop="standard" min-width="80" label="制式" align="center"></el-table-column>
					<el-table-column prop="deliveryTime" min-width="140" label="下发日期" align="center"></el-table-column>
					<el-table-column prop="complaintTime" min-width="200" label="举报日期" align="center"></el-table-column>
					<el-table-column prop="complaintChannel" min-width="140" label="下发渠道"
						align="center"></el-table-column>
					<el-table-column prop="complaintType" min-width="120" label="下发类型" align="center"></el-table-column>
					<el-table-column prop="phoneNumberOfTheComplaint" min-width="140" label="举报号码"
						align="center"></el-table-column>
					<el-table-column prop="phoneNumberOfTheComplaintInfo" min-width="140" label="归属地"
						align="center"></el-table-column>
					<el-table-column prop="phoneNumber" min-width="140" label="被举报号码" align="center"></el-table-column>
					<el-table-column prop="complaintContent" label="举报内容" align="center"
						show-overflow-tooltip></el-table-column>
					<el-table-column prop="vestingPerson" min-width="200" label="归属人" align="center"></el-table-column>
					<el-table-column prop="companyName" min-width="200" label="投诉对应企业" align="center"></el-table-column>
					<el-table-column prop="isReduction" min-width="120" label="是否提交核减" align="center"></el-table-column>
					<el-table-column prop="whetherPay" min-width="120" label="罚款是否收回" align="center"></el-table-column>
					<el-table-column prop="payAmount" min-width="160" label="实际收回金额" align="center"></el-table-column>
					<el-table-column prop="appealSuccessfully" label="申诉成功" align="center"></el-table-column>
					<el-table-column prop="appealFailure" label="申诉失败" align="center"></el-table-column>
					<el-table-column prop="appealRejected" label="申诉驳回" align="center"></el-table-column>
					<el-table-column label="操作" min-width="190" align="center" fixed="right">
						<template #default="scope">
							<el-button size="small" style="cursor: pointer;" type="text" icon="el-icon-edit"
								@click="handleEdit(scope.row)">编辑</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="pagination">
					<el-pagination background layout="total, sizes, prev, pager, next, jumper"
						:current-page="query.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
						:page-size="query.pageSize" :total="pageTotal" @size-change="handleSizeChange"
						@current-change="handlePageChange"></el-pagination>
				</div>
				<div class="customer">
					<el-dialog title="文件导入" v-model="upload" width="500px" @close="closeUpload()"
						:close-on-click-modal="false">
						<el-upload ref="upload" action="/api/blackList/uploadWorkOrder" :headers="token" :limit="1"
							:on-success="uploadSuccess" :on-preview="handlePreview" :on-remove="handleRemove"
							:auto-upload="false" :data="uploadData">
							<el-button size="small" type="primary" :class="[theme]"
								style="margin-top: 40px;">选择文件</el-button>
							<div class="el-upload__tip">只能导入excel文件</div>
						</el-upload>
						<el-button size="small" style="margin: 10px 0 0 80%;" type="primary" :class="[theme]"
							v-loading.fullscreen.lock="loading" @click="submitUpload">确定上传</el-button>
					</el-dialog>
				</div>
				<div class="customer">
					<el-dialog title="编辑" v-model="editVisible" width="500px" :close-on-click-modal="false">
						<el-form :model="form" :rules="rules" ref="form" label-width="100px" class="edit-box">
							<el-form-item label="运营商">
								<el-input size="small" v-model="form.operator" disabled></el-input>
							</el-form-item>
							<el-form-item label="下发日期">
								<el-input size="small" v-model="form.deliveryTime" disabled></el-input>
							</el-form-item>
							<el-form-item label="举报日期">
								<el-input size="small" v-model="form.complaintTime" disabled></el-input>
							</el-form-item>
							<el-form-item label="下发渠道">
								<el-input size="small" v-model="form.complaintChannel" disabled></el-input>
							</el-form-item>
							<el-form-item label="下发类型">
								<el-input size="small" v-model="form.complaintType" disabled></el-input>
							</el-form-item>
							<el-form-item label="举报电话">
								<el-input size="small" v-model="form.phoneNumberOfTheComplaint" disabled></el-input>
							</el-form-item>
							<el-form-item label="被举报电话">
								<el-input size="small" v-model="form.phoneNumber" disabled></el-input>
							</el-form-item>
							<el-form-item label="举报内容">
								<el-input size="small" v-model="form.complaintContent" disabled></el-input>
							</el-form-item>
							<el-form-item label="归属人">
								<el-input size="small" v-model="form.vestingPerson" disabled></el-input>
							</el-form-item>
							<el-form-item label="是否提交核减">
								<el-input size="small" v-model="form.isReduction"></el-input>
							</el-form-item>
							<el-form-item label="罚款是否收回">
								<el-input size="small" v-model="form.whetherPay"></el-input>
							</el-form-item>
							<el-form-item label="实际收回金额">
								<el-input size="small" v-model="form.payAmount"></el-input>
							</el-form-item>
							<el-form-item label="申诉成功">
								<el-input size="small" v-model="form.appealSuccessfully"></el-input>
							</el-form-item>
							<el-form-item label="申诉失败">
								<el-input size="small" v-model="form.appealFailure"></el-input>
							</el-form-item>
							<el-form-item label="申诉驳回">
								<el-input size="small" v-model="form.appealRejected"></el-input>
							</el-form-item>
							<el-form-item>
								<el-button size="small" style="margin-left: 55%;"
									@click="editVisible = false">取消</el-button>
								<el-button size="small" type="primary" :class="[theme]"
									@click="edit('form')">确定</el-button>
							</el-form-item>
						</el-form>
					</el-dialog>
				</div>
			</el-tab-pane>
		</el-tabs>
		<div class="paw-Box">
			<el-dialog title="密码验证" v-model="pawBox" width="400px" :close-on-click-modal="false">
				<el-form :model="formPawBox" ref="formPawBox" label-width="100px" class="edit-box"
					@submit.native.prevent="submitPassWord">
					<el-form-item label="密码验证">
						<el-input type="password" size="small" v-model="formPawBox.passWord"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button size="small" style="margin-left: 55%;" @click="pawBox = false">取消</el-button>
						<el-button size="small" type="primary" :class="[theme]" native-type="submit">确定</el-button>
					</el-form-item>
				</el-form>
			</el-dialog>
		</div>
		<el-dialog title="添加备注" v-model="addVisible" width="450px" :close-on-click-modal="false">
			<el-form :model="addForm" ref="addForm" label-width="120px">
				<el-form-item label="备注">
					<el-input size="small" type="textarea" :rows="5" placeholder="请填写备注"
						v-model="addForm.content"></el-input>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="closeDialog">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" @click="submitAdd">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="记录" v-model="recordVisible" width="450px" :close-on-click-modal="false">
			<el-table :data="recordTableData" border class="table" ref="multipleTable"
				header-cell-class-name="table-header" :header-cell-style="{ 'text-align': 'center' }"
				:row-style="{ height: '20px' }" :cell-style="{ padding: '6px' }" stripe style="width: 100%">
				<el-table-column prop="content" label="备注" align="center"></el-table-column>
				<el-table-column prop="time" label="时间" align="center"></el-table-column>
			</el-table>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getupdateDownRecord,
		downloadDownRecord,
		getWorkOrderList,
		updateWorkOrder,
		uploadWorkOrder,
		downloadWorkOrder,
		verifyPassWord,
		batchDelete,
		agentWorkOrder,
		companyWorkOrder,
		downloadWorkOrderTemplate,
		addWorkOrderLog,
		downloadAgentWorkOrder,
		downloadCompanyWorkOrder
	} from '../api/reportNumber.js';
	import {
		fetchDepartment
	} from '../api/index.js';
	import {
		fetchAgent
	} from '../api/agentIndex.js';
	import {
		fetchCompanyByAgentId,
		fetchDefaultCompanies
	} from '../api/companyIndex';
	import {
		getCardType
	} from '../api/cardType.js';
	import {
		log
	} from '../api/jssip-3.6.3.js';
	export default {
		name: 'workOrder',
		data() {
			return {
				loading: false,
				theme: localStorage.getItem('theme'),
				theme3: localStorage.getItem('theme3'),
				theme8: localStorage.getItem('theme8'),
				query: {
					pageIndex: 1,
					pageSize: 10,
					vestingPerson: '',
					phoneNumber: '',
					phoneNumberOfTheComplaint: '',
					operator: '',
					complaintChannel: '',
					complaintType: '',
					standard: '',
					startTime: '',
					endTime: '',
					userId: localStorage.getItem('user'),
					whetherPay: '',
					appealSuccessfully: '',
					companyName: '',
				},
				timeArr: [],
				timeArr3: [],
				companyNameList: [],
				complaintChannelList: [{
					value: '12321举报中心'
				}, {
					value: '公安部协查'
				}, {
					value: '省公安协查'
				}],
				complaintTypeList: [{
					value: '骚扰电话'
				}, {
					value: '诈骗电话'
				}],

				cardTypeData: [],
				vestingPersonList: [],
				tableData: [],
				multipleSelection: [],
				delList: [],
				pageTotal: 0,
				path: process.env.BASE_URL,
				idx: -1,
				id: -1,

				token: {
					Authorization: localStorage.getItem('token'),
					type: 'web',
					UserRole: localStorage.getItem('ms_role'),
					XSecurityVersion: 'v2',
				},
				upload: false,
				isAdmin: false,
				editVisible: false,
				str: '', //多选
				whetherPayList: [{
					label: '是',
					value: '0'
				}, {
					label: '否',
					value: '1'
				}],
				appealSuccessfullyList: [{
					label: '是',
					value: '0'
				}, {
					label: '否',
					value: '1'
				}],
				standardList: [{
						value: '联通',
						label: '联通',
					},
					{
						value: '电信',
						label: '电信',
					},
					{
						value: '移动',
						label: '移动',
					}
				],
				form: {
					pageIndex: 1,
					pageSize: 10,
					vestingPerson: '',
					phoneNumberOfTheComplaint: '',
					operator: '',
					complaintChannel: '',
					complaintType: '',
					endTime: '',
					startTime: '',
					userId: '',
				},
				uploadData: {
					userId: localStorage.getItem('user'),
				},
				pawBox: false,
				formPawBox: {
					passWord: '',
					userId: localStorage.getItem('user'),
				},

				activeName: 'adminComplaintBoard',
				query2: {
					operator: '',
					standard: '',
					startTime: '',
				},
				tableData2: [],
				timeArr2: '',
				query3: {
					startTime: '',
					endTime: '',
					agentId: '',
					companyId: '',
					operator: '',
					standard: '',
					pageIndex: 1,
					pageSize: 10,
				},
				tableData3: [],
				pageTotal3: 0,
				customData: '',
				customDataTotal: '',
				addVisible: false,
				addForm: {
					content: '',
				},
				addType: '1',
				recordTableData: [],
				recordVisible: false,
			};
		},
		created() {
			let role = localStorage.getItem('ms_role');
			this.init();
			this.getTime2();
			this.updateTabStyle();
			if (role === 'normal') {
				this.isNormal = false;
			}
			if (role === 'admin') {
				this.isAdmin = true;
			}
			if (role === 'agent') {
				this.isAgent = true;
			}
			if (localStorage.getItem('timestamp')) {
				this.getAgentWorkOrder();
				this.getCardTypes();
			} else {
				this.pawBox = true;
				this.tableData = [];
				this.tableData2 = [];
				this.tableData3 = [];
				localStorage.removeItem('timestamp');
			}
			this.updatePaginationStyle();
		},
		methods: {
			updatePaginationStyle(){
				let pagination = document.getElementById('pagination');
				if (!pagination) {
					pagination = document.createElement('style');
					pagination.id = 'dynamic-tab-style';
					document.head.appendChild(pagination);
				}
				pagination.innerHTML = `
				    .active {
				        background-color: ${this.theme8} !important;
						color: #fff !important;
				    }
					.number:hover {
				        color: ${this.theme8} !important;
				    }
					.active:hover {
					    color: #fff !important;
					}
					.more:hover {
					    color: ${this.theme8} !important;
					}
				`;
			},
			updateTabStyle() {
				// 动态更新样式
				let styleEl = document.getElementById('dynamic-tab-style');
				if (!styleEl) {
					styleEl = document.createElement('style');
					styleEl.id = 'dynamic-tab-style';
					document.head.appendChild(styleEl);
				}

				styleEl.innerHTML = `
			        .el-tabs__active-bar {
			            background-color: ${this.theme8} !important;
			        }
			        .el-tabs__item.is-active {
			            color: ${this.theme8} !important;
			        }
			        .el-tabs__item:hover {
			            color: ${this.theme8} !important;
			            opacity: 0.8;
			        }
			    `;
			},
			handleClick(tab, event) {
				this.activeName = tab.props.name;
				if (tab.props.name == 'adminComplaintBoard') {
					this.addType = '1';
					this.getAgentWorkOrder();
				} else if (tab.props.name == 'agentComplaintBoard') {
					this.getTime3();
					this.addType = '2';
					this.getCompanyWorkOrder();
				} else if (tab.props.name == 'workOrder') {
					this.getTime();
					this.getWorkOrderLists();
				}
			},
			init() {
				fetchAgent(localStorage.getItem('user')).then(res => {
					this.agents = res.data;
				});
				this.getfetchDefaultCompanies();
			},
			getfetchDefaultCompanies() {
				this.query.companyId = '';
				let data = {
					currentUserId: localStorage.getItem('user'),
					subAgentId: this.query.subAgentId

				};
				fetchDefaultCompanies(data).then(res => {
					if (res?.code === 200) {
						this.companys = res.data;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			agentChange(agentId) {
				this.query.agentId = agentId;
				this.query.userId = '';
				this.query.companyId = '';
				if (agentId) {
					let data = {
						subAgent: JSON.parse(localStorage.getItem('subAgent').toLowerCase()),
						agentId: agentId
					};
					fetchCompanyByAgentId(data).then(res => {
						this.companys = res.data;
					});
				}
			},
			companyChange(companyId) {
				this.query.companyId = companyId;
				this.query.userId = '';
				this.query.companyId = companyId;
				let data = {
					companyId: companyId,
					currentUserId: localStorage.getItem('user')
				};
				fetchDepartment(data).then(res => {
					this.departments = res.data;
				});
			},
			getWorkOrderLists() {
				if (Date.parse(new Date()) - localStorage.getItem('timestamp') > 1000 * 60 * 60 * 3) {
					this.pawBox = true;
					this.tableData = [];
					localStorage.removeItem('timestamp');
				} else {
					if (this.timeArr === null) {
						this.query.startTime = '';
						this.query.endTime = '';
						this.$message.error('时间不能为空');
					} else {
						let startTime = this.toDateTimeStr(this.timeArr[0]);
						let endTime = this.toDateTimeStr(this.timeArr[1]);
						this.query.startTime = startTime;
						this.query.endTime = endTime;
					}
					let data = {
						userId: localStorage.getItem('user'),
						pageSize: this.query.pageSize,
						pageIndex: this.query.pageIndex,
						vestingPerson: this.query.vestingPerson,
						phoneNumberOfTheComplaint: this.query.phoneNumberOfTheComplaint,
						phoneNumber: this.query.phoneNumber.replaceAll(' ', ''),
						operator: this.query.operator,
						standard: this.query.standard,
						complaintChannel: this.query.complaintChannel,
						complaintType: this.query.complaintType,
						companyName: this.query.companyName,
						startTime: this.query.startTime,
						endTime: this.query.endTime,
						whetherPay: this.query.whetherPay,
						appealSuccessfully: this.query.appealSuccessfully,
					};
					this.loading = true;
					getWorkOrderList(data).then(res => {
						this.loading = false;
						if (res?.code === 200) {
							localStorage.setItem('timestamp', Date.parse(new Date()));
							this.tableData = res.data.list;
							this.pageTotal = res.data.total;
						} else {
							this.$message.error(res.message);
						}
					});
				}
			},
			getAgentWorkOrder() {
				if (Date.parse(new Date()) - localStorage.getItem('timestamp') > 1000 * 60 * 60 * 3) {
					this.pawBox = true;
					localStorage.removeItem('timestamp');
				} else {
					if (this.timeArr2 === null) {
						this.$message.error('时间不能为空');
					} else {
						this.query2.startTime = this.toDateTimeStr2(this.timeArr2);
					}
					this.tableData2 = [];
					let data = {
						userId: localStorage.getItem('user'),
						operator: this.query2.operator,
						standard: this.query2.standard,
						startTime: this.query2.startTime,
						endTime: this.query2.endTime,
					};
					agentWorkOrder(data).then(res => {
						if (res?.code === 200) {
							localStorage.setItem('timestamp', Date.parse(new Date()));
							// this.tableData2 = res.data;
							res.data.forEach(i => {
								i.complaintRatio = (i.use / i.totalCount).toFixed(0)
								this.tableData2.push(i);
							})
							this.customDataTotal = res.data.reduce((acc, item) => {
								acc.totalCount += item.totalCount;
								acc.use += item.use;
								acc.sr += item['12321sr'];
								acc.zp += item['12321zp'];
								acc.gab += item.gab;
								acc.sga += item.sga;
								return acc;
							}, {
								totalCount: 0,
								sr: 0,
								use: 0,
								zp: 0,
								gab: 0,
								sga: 0
							});
						} else {
							this.$message.error(res.message);
						}

					});
				}
			},
			//下载代理商
			getdownloadAgentWorkOrder() {
				if (Date.parse(new Date()) - localStorage.getItem('timestamp') > 1000 * 60 * 60 * 3) {
					this.pawBox = true;
					this.tableData = [];
					localStorage.removeItem('timestamp');
				} else {
					if (this.timeArr2 === null) {
						this.$message.error('时间不能为空');
					} else {
						this.query2.startTime = this.toDateTimeStr2(this.timeArr2);
					}
					let data = {
						userId: localStorage.getItem('user'),
						operator: this.query2.operator,
						startTime: this.query2.startTime,
						endTime: this.query2.endTime,
					};
					downloadAgentWorkOrder(data).then(res => {
						localStorage.setItem('timestamp', Date.parse(new Date()));
						const blob = new Blob([res], {
							type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
						});
						let downloadElement = document.createElement('a');
						let href = window.URL.createObjectURL(blob);
						downloadElement.href = href;
						let fileName = this.query2.startTime + '代理商投诉一览表' + '.xlsx';
						downloadElement.download = fileName;
						document.body.appendChild(downloadElement);
						downloadElement.click();
						document.body.removeChild(downloadElement);
						window.URL.revokeObjectURL(href);
					});
				}
			},

			getCompanyWorkOrder() {
				if (Date.parse(new Date()) - localStorage.getItem('timestamp') > 1000 * 60 * 60 * 3) {
					this.pawBox = true;
					this.tableData = [];
					localStorage.removeItem('timestamp');
				} else {
					if (this.timeArr3 === null) {
						this.query3.startTime = '';
						this.query3.endTime = '';
						this.$message.error('时间不能为空');
					} else {
						let startTime = this.toDateTimeStr(this.timeArr3[0]);
						let endTime = this.toDateTimeStr(this.timeArr3[1]);
						this.query3.startTime = startTime;
						this.query3.endTime = endTime;
					}
					let data = {
						userId: localStorage.getItem('user'),
						operator: this.query3.operator,
						startTime: this.query3.startTime,
						endTime: this.query3.endTime,
						companyId: this.query3.companyId,
						standard: this.query3.standard,
						agentId: this.query3.agentId,
						pageSize: this.query3.pageSize,
						pageIndex: this.query3.pageIndex,
					};
					this.loading = true;
					companyWorkOrder(data).then(res => {
						this.loading = false;
						if (res?.code === 200) {
							localStorage.setItem('timestamp', Date.parse(new Date()));
							this.tableData3 = res.data.list;
							this.pageTotal3 = res.data.total;
							this.customData = res.customData;
						} else {
							this.$message.error(res.message);
						}

					});
				}
			},
			//下载企业
			getdownloadCompanyWorkOrder() {
				if (Date.parse(new Date()) - localStorage.getItem('timestamp') > 1000 * 60 * 60 * 3) {
					this.pawBox = true;
					this.tableData = [];
					localStorage.removeItem('timestamp');
				} else {
					if (this.timeArr3 === null) {
						this.query3.startTime = '';
						this.query3.endTime = '';
						this.$message.error('时间不能为空');
					} else {
						let startTime = this.toDateTimeStr(this.timeArr3[0]);
						let endTime = this.toDateTimeStr(this.timeArr3[1]);
						this.query3.startTime = startTime;
						this.query3.endTime = endTime;
					}
					let data = {
						userId: localStorage.getItem('user'),
						operator: this.query3.operator,
						startTime: this.query3.startTime,
						endTime: this.query3.endTime,
						companyId: this.query3.companyId,
						agentId: this.query3.agentId,
						pageSize: this.query3.pageSize,
						pageIndex: this.query3.pageIndex,
					};
					downloadCompanyWorkOrder(data).then(res => {
						localStorage.setItem('timestamp', Date.parse(new Date()));
						const blob = new Blob([res], {
							type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
						});
						let downloadElement = document.createElement('a');
						let href = window.URL.createObjectURL(blob);
						downloadElement.href = href;
						let fileName = this.query3.startTime + '至' + this.query3.endTime + '企业投诉' + '.xlsx';
						downloadElement.download = fileName;
						document.body.appendChild(downloadElement);
						downloadElement.click();
						document.body.removeChild(downloadElement);
						window.URL.revokeObjectURL(href);
					});
				}
			},
			//品牌
			getCardTypes() {
				if (Date.parse(new Date()) - localStorage.getItem('timestamp') > 1000 * 60 * 60 * 3) {
					this.pawBox = true;
					this.tableData = [];
					localStorage.removeItem('timestamp');
				} else {
					getCardType().then(res => {
						if (res?.code === 200) {
							this.cardTypeData = res.data;
						} else {
							this.$message.error(res.message);
						}
					});
				}
			},
			toDateTimeStr2(date) {
				let y = date.getFullYear();
				let m = date.getMonth() + 1;
				let d = date.getDate();
				if (m < 10) {
					m = '0' + m;
				}
				return y + '-' + m;
			},
			toDateTimeStr(date) {
				let y = date.getFullYear();
				let m = date.getMonth() + 1;
				let d = date.getDate();
				if (m < 10) {
					m = '0' + m;
				}
				if (d < 10) {
					d = '0' + d;
				}
				return y + '-' + m + '-' + d;
			},
			//筛选时间
			getTime() {
				//时间
				let startTime = new Date(new Date());
				let endTime = new Date();
				this.timeArr.push(startTime);
				this.timeArr.push(endTime);
			},
			//筛选时间
			getTime3() {
				//时间
				let startTime = new Date(new Date());
				let endTime = new Date();
				this.timeArr3.push(startTime);
				this.timeArr3.push(endTime);
			},
			getTime2() {
				//时间
				this.timeArr2 = new Date(new Date())
			},
			//导入
			importForm() {
				if (Date.parse(new Date()) - localStorage.getItem('timestamp') > 1000 * 60 * 60 * 3) {
					this.pawBox = true;
					this.tableData = [];
					localStorage.removeItem('timestamp');
				} else {
					this.upload = true;
				}
			},
			//导入上传
			uploadSuccess(success) {
				setTimeout(() => {
					this.loading = false;
					this.$refs.upload.clearFiles();
					this.upload = false;
				}, 2000);
				if (success?.code === 200) {
					this.$message.success('上传成功');
					this.getWorkOrderLists();
				} else {
					this.$message.error(success.message);
				}
			},
			submitPassWord() {
				verifyPassWord(this.formPawBox).then(res => {
					if (res?.code === 200) {
						if (res.data == true) {
							this.$message.success('验证成功');
							localStorage.setItem('timestamp', Date.parse(new Date()));
							this.pawBox = false;
							this.formPawBox.passWord = '';
							this.getAgentWorkOrder();
							this.getCardTypes();

						} else {
							this.formPawBox.passWord = '';
							this.$message.error('验证失败');
						}
					} else {
						this.$message.error(res.message);
					}
				});
			},
			closeUpload() {
				this.$refs.upload.clearFiles();
			},
			submitUpload() {
				if (this.$refs.upload.uploadFiles[0]) {
					this.loading = true;
					this.$refs.upload.submit();
				} else {
					this.$message.error('请选择上传文件');
				}
			},

			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handlePreview(file) {
				console.log(file);
			},

			// 编辑操作
			handleEdit(row) {
				this.form = row;
				this.editVisible = true;
			},

			edit(formName) {
				this.$refs[formName].validate(valid => {
					if (valid) {
						this.loading = true;
						this.form.userId = localStorage.getItem('user');
						if (Date.parse(new Date()) - localStorage.getItem('timestamp') > 1000 * 60 *
							60 * 3) {
							this.pawBox = true;
							this.tableData = [];
							localStorage.removeItem('timestamp');
						} else {
							updateWorkOrder(this.form).then(res => {
								if (res?.code === 200) {
									this.$message.success('修改成功');
									this.getWorkOrderLists();
								} else {
									this.$message.error(res.message);
								}
								this.editVisible = false;
							});
						}
					}
				});
			},
			// 触发搜索按钮
			handleSearch() {
				this.query.pageIndex = 1;
				this.getWorkOrderLists();
			},
			exportData() {
				this.loading = true;
				this.query.userId = localStorage.getItem('user');
				if (Date.parse(new Date()) - localStorage.getItem('timestamp') > 1000 * 60 * 60 * 3) {
					this.pawBox = true;
					this.tableData = [];
					localStorage.removeItem('timestamp');
				} else {
					let str = '';
					this.delList = this.delList.concat(this.multipleSelection);
					for (let i = 0; i < this.multipleSelection.length; i++) {
						str += this.multipleSelection[i].id + ',';
					}
					this.query.ids = str;
					downloadWorkOrder(this.query).then(res => {
						const blob = new Blob([res], {
							type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
						});
						let downloadElement = document.createElement('a');
						let href = window.URL.createObjectURL(blob);
						downloadElement.href = href;
						let fileName = '工单记录' + '.xlsx';
						downloadElement.download = fileName;
						document.body.appendChild(downloadElement);
						downloadElement.click();
						document.body.removeChild(downloadElement);
						window.URL.revokeObjectURL(href);
						this.loading = false;
						this.getWorkOrderLists();
					});
				}
			},

			// 分页导航
			handlePageChange(val) {
				this.query.pageIndex = val;
				this.getWorkOrderLists();
			},
			handleSizeChange(val) {
				this.query.pageSize = val;
				this.query.pageIndex = 1; // 重置到第一页
				this.getWorkOrderLists();
			},

			// 分页导航
			handlePageChange3(val) {
				this.query3.pageIndex = val;
				this.getCompanyWorkOrder();
			},
			handleSizeChange3(val) {
				this.query3.pageSize = val;
				this.query3.pageIndex = 1; // 重置到第一页
				this.getCompanyWorkOrder();
			},
			// 多选操作
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			/* 删除 */
			batchDel() {
				let str = '';
				this.delList = this.delList.concat(this.multipleSelection);
				for (let i = 0; i < this.multipleSelection.length; i++) {
					str += this.multipleSelection[i].id + ',';
				}
				if (str === '') {
					this.$message.error(`请选择线索`);
					return;
				} else {
					let param = {
						ids: str
					};
					// 二次确认删除
					this.$confirm('确定要删除吗？', '提示', {
							type: 'warning'
						})
						.then(() => {
							batchDelete(param).then(res => {
								if (res?.code === 200) {
									this.$message.success(res.data);
									this.getWorkOrderLists();
								} else {
									this.$message.error(res.message);
								}
							});
						})
						.catch(() => {});
				}
				this.multipleSelection = [];
			},
			//下载磨板
			getdownload() {
				downloadWorkOrderTemplate().then(res => {
					const blob = new Blob([res], {
						type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
					});
					let downloadElement = document.createElement('a');
					let href = window.URL.createObjectURL(blob);
					downloadElement.href = href;
					let fileName = '工单管理' + '.xlsx';
					downloadElement.download = fileName;
					document.body.appendChild(downloadElement);
					downloadElement.click();
					document.body.removeChild(downloadElement);
					window.URL.revokeObjectURL(href);
				});
			},
			showAdd(row) {
				this.addForm.content = '';
				this.addForm.agentId = '';
				this.addForm.companyId = '';
				this.addVisible = true;
				this.addForm.agentId = row.agentId;
				this.addForm.companyId = row.companyId;
			},
			showRecord(row) {
				this.recordTableData = row.workOrderLog;
				this.recordVisible = true;
			},
			closeDialog() {
				this.addVisible = false;
				this.recordVisible = false;
			},
			submitAdd() {
				let data = {
					userId: localStorage.getItem('user'),
					content: this.addForm.content,
					type: this.addType,
					agentId: this.addForm.agentId,
					companyId: this.addForm.companyId,
				}
				addWorkOrderLog(data).then(res => {
					if (res?.code === 200) {
						this.addVisible = false;
						this.$message.success(res.data);
						if (this.addType == '1') {
							this.getAgentWorkOrder();
						} else if (this.addType == '2') {
							this.getCompanyWorkOrder();
						}
					} else {
						this.$message.error(res.message);
					}
				});

			},
		}
	};
</script>

<style scoped>
	.handle-box {
		margin-bottom: 20px;
	}

	.down {
		border: 1px solid #dcdfe6;
		background: #4f7afd;
		color: #ffffff;
		transition: 0.1s;
		font-weight: 500;
		padding: 6px 12px;
		font-size: 12px;
		border-radius: 4px;
		display: inline-block;
	}

	.handle-select {
		width: 240px;
	}

	.table {
		width: 100%;
		font-size: 12px;
	}

	.red {
		color: #f56c6c;
	}

	.mr10 {
		margin-right: 10px;
	}

	.mr100 {
		position: absolute;
		right: 100px;
	}

	.myRight {
		position: absolute;
		right: 10px;
		bottom: 10px;
	}

	.handle-input {
		width: 200px;
		display: inline-block;
	}

	.customer .el-upload {
		display: flex !important;
		flex-direction: column !important;
		align-items: center !important;
		justify-content: center !important;
		width: 100% !important;
		line-height: 50px !important;
	}

	.customer .btn {
		background-color: #4f7afd;
		margin-top: 20px;
		display: flex;
		flex-direction: row;
		justify-content: flex-end;
		border: none;
		margin-left: 80%;
	}

	/deep/.edit-box .el-form-item {
		margin-bottom: 8px !important;
	}

	.tablemasaik {
		background-image: url(../assets/img/masaike.jpg) !important;
	}

	.card-body {
		color: rgba(0, 0, 0, 0.65);
		background: #fff;
		border-radius: 2px;
		box-sizing: border-box;
		padding: 24px 0;

	}

	.card-body .tit {
		font-weight: 700;
		color: rgba(0, 0, 0, 0.85);
		margin-bottom: 1em;
		font-size: 14px;
		font-variant: tabular-nums;
		line-height: 1.5;
		list-style: none;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}

	.el-icon-s-data,
	.el-icon-postcard,
	.el-icon-finished {
		font-size: 20px;
		margin-right: 5px;
		color: #1890FF;
	}

	.card-body .card-list {
		display: flex;
		flex-direction: row;
	}

	.card-body .card-list div {
		padding-left: 12px;
		padding-right: 12px;
		padding: 24px;
		zoom: 1;
		width: 23%;
		display: flex;
		flex-direction: column;
		margin-right: 2%;
	}

	.card-body .tit .tit-btn .active {
		color: #fff;
	}

	.card-body .card-list .card-list-tit {
		font-size: 14px;
		color: rgba(0, 0, 0, 0.65);
	}

	.card-body .card-list .card-list-data {
		font-size: 24px;
		margin-top: 10px;
		font-weight: 700;
	}

	.card-body .card-list .card-list-qoq {
		font-size: 12px;
		margin-top: 10px;
	}

	.bg_ecf4ff {
		background: #ecf4ff;
	}

	.bg_dfeef3 {
		background: #dfeef3;
	}

	.bg_f8f0f9 {
		background: #f8f0f9;
	}

	.bg_f0f2f5 {
		background: #f0f2f5;
	}

	.bg_f8f3f9 {
		background: rgba(247, 172, 189, 0.4);
	}
</style>
<style>
	.customer .el-upload {
		width: 100% !important;
		display: flex !important;
		flex-direction: column !important;
		align-items: center !important;
		justify-content: center !important;
	}

	.customer .btn {
		background-color: #4f7afd;
		margin-top: 20px;
		display: flex;
		flex-direction: row;
		justify-content: flex-end;
		border: none;
		margin-left: 80%;
	}
</style>